export default __webpack_public_path__ + "static/media/whatsapp_blue_404.74822513.svg";